import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as ControlledInputsActions from '../actions/controlled-inputs.actions';
import { catchError, exhaustMap, switchMap, tap } from 'rxjs/operators';
import {of} from 'rxjs';
import {ControlledInputService} from '../../../units/services/controlled-input.service';
import { LoadingBarState } from '@ngx-loading-bar/core/loading-bar.state';
import { LoadingBarService } from '@ngx-loading-bar/core';

@Injectable()
export class ControlledInputsEffects {

  getControlledInputs$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ControlledInputsActions.getControlledInputs.type),
      switchMap(action =>
        this._controlledInputService.getControlledInputs(action['unitIds'])
          .pipe(
            exhaustMap(data => of(ControlledInputsActions.getControlledInputsSuccess({controlledInputs: data}))),
            catchError(error => of(ControlledInputsActions.getControlledInputsFailure({error})))
          )
      )
    )
  );

  updateControlledInput$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ControlledInputsActions.updateControlledInput.type),
      tap(() => this._loader.start()),
      switchMap(action =>
        this._controlledInputService.updateControlledInput(action['data'])
          .pipe(
            exhaustMap(data => of(ControlledInputsActions.updateControlledInputSuccess({data: data}))),
            catchError(error => of(ControlledInputsActions.updateControlledInputFailure({error}))),
            tap(() => this._loader.complete()),
          )
      )
    )
  );


  cancelControlledInputUpdate$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ControlledInputsActions.cancelControlledInputUpdate.type),
      tap(() => this._loader.start()),
      exhaustMap(action =>
        this._controlledInputService.cancelControlledInputUpdate(action['data'])
          .pipe(
            exhaustMap(data => of(ControlledInputsActions.cancelControlledInputUpdateSuccess({data: data}))),
            catchError(error => of(ControlledInputsActions.cancelControlledInputUpdateFailure({error}))),
            tap(() => this._loader.complete()),
          )
      )
    )
  );

  private _loader: LoadingBarState;

  constructor(
    private _actions$: Actions,
    private _controlledInputService: ControlledInputService,
    private _loadingBar: LoadingBarService
  ) {
    this._loader = this._loadingBar.useRef('main');
  }
}
